import {createFileRoute} from "@tanstack/react-router";

import {routeMessages} from "../../../../../../messages/routes.messages";

import {OfferPreviewPage} from "./-page/offer-preview.page";
import {OfferPreviewPending} from "./-page/offer-preview.pending";

export const Route = createFileRoute("/_app/sales/offers/$offerId/preview/")({
  component: RouteComponent,
  pendingComponent: OfferPreviewPending,
  staticData: {meta: {labelDescriptor: routeMessages.preview}},
});

function RouteComponent() {
  const {offerId} = Route.useParams();

  return <OfferPreviewPage offerId={offerId} />;
}
